function resolveDex(host) {
	if (host.includes('sgbuildex')) return 'sgbuildex';
	if (host.includes('sghealthdex')) return 'sghealthdex';
	if (host.includes('sgtradex.io') || host.includes('afa-cdi.com')) return 'sgtradex';
	return null;
}

// Unified-portal hostnames (e.g. `unified-portal.dev.dextech.ai`) don't carry
// the dex in the hostname — portal writes it to sessionStorage when the user
// picks a brand tile. Read that first; fall back to hostname matching for
// direct legacy URL access.
function resolveDexFromStorage() {
	if (typeof window === 'undefined' || !window.sessionStorage) return null;
	return window.sessionStorage.getItem('selectedDex');
}

// Captcha keys are indexed by env, so an unknown env off localhost would silently drop the captcha.
const DEPLOYED_ENVS = ['dev', 'test', 'uat', 'pre-prod', 'prod'];

// Env from the build, not the hostname: tenant names can contain env words (DXT-859).
export function getEnvAndDex() {
	const host = window.location.hostname;
	const env = process.env.REACT_APP_ENV;
	const dex = resolveDexFromStorage() ||
		(host === 'localhost' ? process.env.REACT_APP_DEX_ENV : resolveDex(host));

	if (!env || !dex || (host !== 'localhost' && !DEPLOYED_ENVS.includes(env))) {
		throw new Error(`Unable to determine env or dex for host: ${host} (env: ${env})`);
	}

	return { env, dex };
}
